<template>
  <div class="h-full w-full max-w-full rounded-lg flex flex-col gap-2">
    <div
      class="w-full max-w-full flex flex-col gap-2 overflow-y-auto scrollbar-thin scrollbar-tema"
      ref="scrollContainer"
    >
      <div class="w-full max-w-full flex gap-2">
        <AppSucursalForm
          :show="show_form"
          :form_title="form_title"
          :create_btn="create_sucursal_"
          :form_data="sucursal_formData"
          :set_data="sucursal_setData"
          @close="closeForm"
          @show_table="show_form_table"
          @create="create_sucursal"
          @update="update_sucursal"
          @disable="disable_sucursal"
          @remove="remove_sucursal"
        />

        <AppTable
          :visibility="true"
          :show="show_generic_table"
          :table_data="generic_table_data"
          :table_title="generic_table_title"
          @row-clicked="select_generic_row"
          @close="close_generic_table"
        />

        <AppAddressMap
          v-if="show_address"
          :initialAddress="sucursal_endereco"
          @close="close_address()"
          @save="update_address"
        />
      </div>

      <div class="w-full">
        <GenericDataTable
          v-if="validPermission('SU0002')"
          ref="dataTableRef"
          @row-click="select_sucursal"
          :api-url="`${baseURl}/api/v1/sucursal/pagination/`"
          :useServerSide="true"
          :columns="sucursalColumns"
          :preserve-api-order="true"
          :show_export="true"
          :show_close_btn="false"
          table_title="Sucursais"
        >
          <template #left-actions>
            <button v-if="validPermission('SU0003')"
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'create_sucursal' })"
              title="Adicionar"
            >
              <i class="fa-solid fa-circle-plus fa-xl"></i>
            </button>
          </template>
        </GenericDataTable>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AppTable from "@/components/tables/table.vue";
import AppAddressMap from "@/components/addressMap.vue";
import AppSucursalForm from "@/components/forms/sucursal/sucursalForm.vue";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";
import permissionMixin from "@/permissionMixin.js";
import { toast } from "vue3-toastify";
import "@fortawesome/fontawesome-free/css/all.css";

export default {
  mixins: [permissionMixin],
  name: "appsucursais",
  components: {
    AppTable,
    AppAddressMap,
    AppSucursalForm,
    GenericDataTable,
  },
  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,

      sucursal: {},
      zonas: [],

      generic_table_data: [],
      generic_table_title: "Generic Table",
      current_table: "none",

      show_form: false,
      show_generic_table: false,
      show_address: false,

      form_title: "No Title",
      create_sucursal_: false,

      sucursal_formData: {},
      sucursal_setData: {},
      sucursal_endereco: {},

      sucursalColumns: [
        {
          key: "sucursal",
          label: "Sucursal",
          type: "text",
          maxWidth: 250,
        },
        {
          key: "zona",
          label: "Zona",
          type: "text",
          maxWidth: 150,
        },
        {
          key: "morada",
          label: "Morada",
          type: "text",
          maxWidth: 250,
        },
        {
          key: "endereco",
          label: "Localidade",
          type: "text",
          maxWidth: 200,
        },
        {
          key: "status",
          label: "Status",
          type: "badge",
          maxWidth: 90,
        },
      ],
    };
  },
  async created() {
    this.setSucursalForm(null);
    await this.get_zonas();
  },
  methods: {
    // ------------------------------- helpers -------------------------------
    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error updating data:", error);
      }
    },
    async remove(url) {
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
        return false;
      }
    },

    async get_zonas() {
      const zonas = await this.select_all(`${this.baseURl}/api/v1/tpzona/`);
      this.zonas = (zonas || []).filter((zona) => zona.status == "ativo");
    },

    refreshTable() {
      this.$refs.dataTableRef?.refresh();
    },

    // --------------------------------- CRUD --------------------------------
    async create_sucursal(data) {
      const endereco_id = await this.create_update_endereco();
      const res = await this.create(this.setData(data, endereco_id), `${this.baseURl}/api/v1/sucursal/registrar/`);
      if (res) {
        toast.success("Sucursal criada com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.closeForm();
        this.refreshTable();
      } else {
        toast.error("Erro ao criar Sucursal", { autoClose: 1000 });
      }
    },

    async select_sucursal(data) {
      this.$nextTick(() => {
        this.$refs.scrollContainer?.scrollTo({ top: 0, behavior: "smooth" });
      });
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;

      this.closeAll();
      this.create_sucursal_ = false;
      this.form_title = "Informação Da Sucursal";

      const sucursal = await this.select(`${this.baseURl}/api/v1/sucursal/${data.id}/`);
      if (sucursal) {
        this.sucursal = JSON.parse(JSON.stringify(sucursal));
        this.sucursal_endereco = JSON.parse(JSON.stringify(sucursal.endereco || {}));
        if (isEmptyObject(this.sucursal_endereco)) {
          this.clear_sucursal_endereco();
        }
        this.setSucursalForm(sucursal);
        this.show_form = true;
      }
    },

    async update_sucursal(data) {
      const endereco_id = await this.create_update_endereco();
      const res = await this.update(
        `${this.baseURl}/api/v1/sucursal/editar/${data.id}/`,
        this.setData(data, endereco_id)
      );
      if (res) {
        toast.success("Sucursal atualizada com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.closeForm();
        this.refreshTable();
      } else {
        toast.error("Erro ao atualizar Sucursal", { autoClose: 1000 });
      }
    },

    async disable_sucursal(data) {
      const novoStatus = data.status == "ativo" ? "desativado" : "ativo";
      const res = await this.update(`${this.baseURl}/api/v1/sucursal/editar/${data.id}/`, {
        status: novoStatus,
      });
      if (res) {
        this.sucursal_formData.status = novoStatus;
        toast.success(
          `Sucursal ${novoStatus == "ativo" ? "ativada" : "desativada"} com sucesso`,
          { position: toast.POSITION.TOP_CENTER, autoClose: 1000 }
        );
        this.refreshTable();
      } else {
        toast.error("Erro ao alterar o estado da Sucursal", { autoClose: 1000 });
      }
    },

    async remove_sucursal(data) {
      try {
        await axios.delete(`${this.baseURl}/api/v1/sucursal/eliminar/${data.id}/`);
        toast.success("Sucursal eliminada com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.closeForm();
        this.refreshTable();
      } catch (error) {
        // O backend recusa eliminar sucursais ainda atribuídas a utilizadores.
        toast.error(error?.response?.data?.message || "Erro ao eliminar Sucursal", {
          autoClose: 3000,
        });
      }
    },

    // ------------------------------- endereço ------------------------------
    clear_sucursal_endereco() {
      this.sucursal_endereco = {
        id: 0,
        pais: "",
        morada: "",
        codigoPostal: "",
        freguesia: "",
        localidade: "",
        latitude: "",
        longitude: "",
        concelho: "",
        distrito: "",
      };
    },

    update_address(data) {
      this.sucursal_setData.endereco = data;
      this.sucursal_endereco = JSON.parse(JSON.stringify(data));
      this.close_address();
    },

    // Devolve o endereco_id a gravar na sucursal: cria o endereço quando ainda
    // não existe, atualiza-o quando já existe, 0 quando não foi preenchido.
    async create_update_endereco() {
      const endereco = { ...this.sucursal_endereco };
      const preenchido = ["morada", "localidade", "pais", "codigoPostal"].some(
        (campo) => endereco[campo] && String(endereco[campo]).trim() !== ""
      );
      if (!preenchido) return 0;

      if (!endereco.id) {
        delete endereco.id;
        const res = await this.create(endereco, `${this.baseURl}/api/v1/endereco/registrar/`);
        if (res) {
          this.sucursal_endereco.id = res.id;
          return res.id;
        }
        toast.error("Erro ao criar endereço", { autoClose: 1000 });
        return 0;
      }

      const res = await this.update(
        `${this.baseURl}/api/v1/endereco/editar/${endereco.id}/`,
        endereco
      );
      if (!res) toast.error("Erro ao atualizar endereço", { autoClose: 1000 });
      return endereco.id;
    },

    // -------------------------------- form ---------------------------------
    setSucursalForm(data) {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;

      this.sucursal_formData = {
        id: data && data.id ? data.id : 0,
        sucursal: data && data.sucursal ? data.sucursal : "",
        objetivo_premio: Number(data?.objetivo_premio) || 0,
        objetivo_financeiro: Number(data?.objetivo_financeiro) || 0,
        status: data && data.status ? data.status : "ativo",
      };

      this.sucursal_setData = {
        zona:
          data && data.zona && !isEmptyObject(data?.zona)
            ? data.zona
            : { id: 0, nome: "Não Atribuído" },
        endereco:
          data && data.endereco && !isEmptyObject(data?.endereco) ? data.endereco : {},
      };
    },

    setData(data, endereco_id) {
      return {
        sucursal: data.sucursal || "",
        zona_id: data?.zona?.id || 0,
        endereco_id: endereco_id || 0,
        objetivo_premio: Math.max(Number(data.objetivo_premio) || 0, 0),
        objetivo_financeiro: Math.max(Number(data.objetivo_financeiro) || 0, 0),
        status: data.status || "ativo",
      };
    },

    show_form_table(data) {
      this.close_generic_table();
      this.close_address();

      if (data === "mapa") {
        this.show_address = true;
        return;
      }

      const tableMappings = {
        zona: { data: this.zonas, title: "Zonas" },
      };
      const mapping = tableMappings[data];
      if (mapping) {
        this.current_table = data;
        this.generic_table_data = mapping.data;
        this.generic_table_title = mapping.title;
        this.show_generic_table = true;
      }
    },

    select_generic_row(data) {
      if (this.current_table == "zona") {
        this.sucursal_setData.zona = data;
      }
      this.close_generic_table();
    },

    triggerAction(action) {
      if (action.action === "create_sucursal") {
        this.closeAll();
        this.create_sucursal_ = true;
        this.form_title = "Criar Sucursal";
        this.setSucursalForm(null);
        this.clear_sucursal_endereco();
        this.show_form = true;
      }
    },

    closeAll() {
      this.close_generic_table();
      this.close_address();
      this.show_form = false;
    },
    closeForm() {
      this.show_form = false;
      this.close_generic_table();
      this.close_address();
    },
    close_generic_table() {
      this.show_generic_table = false;
      this.current_table = "none";
    },
    close_address() {
      this.show_address = false;
    },
  },
};
</script>
